export type Item = {
  value: number;
  label: string;
  active?: boolean;
};

export type Filter = {
  id: number;
  label: string;
  isActive: boolean;
  items: Item[];
};

export const administrativeUsersFilters: Filter[] = [
  {
    id: 1,
    label: 'Tipo de usuário',
    isActive: false,
    items: [
      { value: 1, label: 'Todos' },
      { value: 2, label: 'Supervisor' },
      { value: 3, label: 'Operador' },
    ],
  },
  {
    id: 2,
    label: 'Última sessão',
    isActive: false,
    items: [
      { value: 1, label: 'Todos' },
      { value: 2, label: 'Online' },
      { value: 3, label: 'Sessão delegada ativa' },
      { value: 4, label: 'Sessão encerrada' },
    ],
  },
  {
    id: 3,
    label: 'Acesso delegado',
    isActive: false,
    items: [
      { value: 1, label: 'Todos' },
      { value: 2, label: 'Consentimento pendente' },
      { value: 3, label: 'Solicitação aprovada' },
      { value: 4, label: 'Solicitação negada' },
      { value: 5, label: 'Solicitação expirada' },
      { value: 6, label: 'Solicitação cancelada' },
      { value: 7, label: 'Sessão delegada ativa' },
    ],
  },
];
